import { RouteObject, useRoutes } from 'react-router-dom';
import { RoutesConfig } from 'Routes';
export const Router = () => {
  const privateRoutesConfig: RouteObject[] = [
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.ActivitiesLobby.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.ActivitiesLobby.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.HOME.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.HOME.MODULE,
        },
      ],
    },
    {
      path: RoutesConfig.PRIVATE_LAYOUT.PATH,
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      children: [
        {
          index: true,
          element: RoutesConfig.MEDICATION_AND_PRESCRIPTIONS_LOBBY.MODULE,
        },
        {
          path: RoutesConfig.MEDICATION_HISTORY.PATH,
          element: RoutesConfig.MEDICATION_HISTORY.MODULE,
        },
        {
          element: RoutesConfig.EXPIRED_MEDICATIONS.MODULE,
          path: RoutesConfig.EXPIRED_MEDICATIONS.PATH,
        },
        {
          element: RoutesConfig.MEDICINE_CREATE_ORDER.MODULE,
          path: RoutesConfig.MEDICINE_CREATE_ORDER.PATH,
        },
        {
          path: `${RoutesConfig.MEDICINE_CREATE_ORDER.PATH}/:id`,
          element: RoutesConfig.MEDICINE_CREATE_ORDER.MODULE,
        },
        {
          element: RoutesConfig.MEDICINE_ORDER_INFO.MODULE,
          path: RoutesConfig.MEDICINE_ORDER_INFO.PATH,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.RECOGNITION_STATUS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.STATUS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.SINGLE_STATUS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.SINGLE_STATUS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.PAYCHECKS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.PAYCHECKS.MODULE,
        },
        {
          path: RoutesConfig.PAYCHECKS.PATH + '/:tabId',
          element: RoutesConfig.PAYCHECKS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.APPLIES.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.YOUR_APPLIES.MODULE,
        },
        {
          path: `${RoutesConfig.APPLIES.PATH}/:id`,
          element: RoutesConfig.YOUR_APPLIES.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.EQUIPMENT.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.EQUIPMENT.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.EQUIPMENT_CREATE_ORDER.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.EQUIPMENT_CREATE_ORDER.MODULE,
        },
        {
          path: `${RoutesConfig.EQUIPMENT_CREATE_ORDER.PATH}/:id`,
          element: RoutesConfig.EQUIPMENT_CREATE_ORDER.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.EQUIPMENT_ORDER_INFO.PATH,
      children: [
        {
          index: false,
          element: RoutesConfig.EQUIPMENT_ORDER_INFO.MODULE,
        },
        {
          path: RoutesConfig.EQUIPMENT_ORDER_INFO.PATH,
          element: RoutesConfig.EQUIPMENT_ORDER_INFO.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.TEST_LINKS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.TEST_LINKS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.TEST_COMPONENTS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.TEST_COMPONENTS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.TEST_IMAGES.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.TEST_IMAGES.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.FORMS_DETAILS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.FORMS_DETAILS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: '/requests',
      children: [
        {
          index: false,
          element: RoutesConfig.REQUESTS.MODULE,
        },
        {
          path: RoutesConfig.REQUESTS.PATH,
          element: RoutesConfig.REQUESTS.MODULE,
        },
        {
          path: RoutesConfig.REQUESTS.PATH + '/:sectionId',
          element: RoutesConfig.REQUESTS.MODULE,
        },
      ],
    },
    {
      path: RoutesConfig.CONFIRMATIONS.PATH,
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      children: [
        {
          path: RoutesConfig.CONFIRMATIONS.PATH + '/:docType',
          element: RoutesConfig.CONFIRMATIONS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.PERSONAL_DETAILS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.PERSONAL_DETAILS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.PERSONAL_TEAM.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.PERSONAL_TEAM.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.COMPASS_RIGHTS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.COMPASS_RIGHTS.MODULE,
        },
        {
          path: RoutesConfig.COMPASS_RIGHTS_ENTITLEMENT.PATH,
          element: RoutesConfig.COMPASS_RIGHTS_ENTITLEMENT.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.MEDICAL_REFERRALS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.MEDICAL_REFERRALS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.DISABLED_VETERAN.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.DISABLED_VETERAN.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.TREATMENT.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.TREATMENT.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.CONFIRM_BENEFITS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.CONFIRM_BENEFITS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.DOCUMENTS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.DOCUMENTS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.DOCUMENTS_OLD.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.DOCUMENTS_OLD.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.UPDATES.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.UPDATES.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.UNIVERSAL_REQUEST_LAYOUT.MODULE,
      path: RoutesConfig.UNIVERSAL_REQUEST.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.UNIVERSAL_REQUEST.MODULE,
        },
        {
          path: RoutesConfig.UNIVERSAL_REQUEST.PATH + '/:tabId',
          element: RoutesConfig.UNIVERSAL_REQUEST.MODULE,
        },
        {
          path: RoutesConfig.UNIVERSAL_REQUEST.PATH + '/:tabId/:categoryId',
          element: RoutesConfig.UNIVERSAL_REQUEST.MODULE,
        },
        {
          path:
            RoutesConfig.UNIVERSAL_REQUEST.PATH +
            '/:tabId/:categoryId/:subCategoryId',
          element: RoutesConfig.UNIVERSAL_REQUEST.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.OTP_LOGIN_LAYOUT.MODULE,
      path: RoutesConfig.OTP_LOGIN.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.OTP_LOGIN.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.DOCUMENTS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.DOCUMENTS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.ERROR_LAYOUT.MODULE,
      path: RoutesConfig.ERROR.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.ERROR.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.DISABILITY_APPROVALS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.DISABILITY_APPROVALS.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.SUPPLIERS_LAYOUT.MODULE,
      path: RoutesConfig.SUPPLIERS_LAYOUT.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.SUPPLIERS.MODULE,
        },
        {
          path: `${RoutesConfig.SUPPLIERS_LAYOUT.PATH}/:supplierCategory`,
          element: RoutesConfig.SUPPLIERS.MODULE,
        },
        {
          path: `${RoutesConfig.SUPPLIERS_LAYOUT.PATH}/:supplierCategory/results`,
          element: RoutesConfig.SUPPLIERS.MODULE,
        },
        {
          path: `${RoutesConfig.SUPPLIERS_LAYOUT.PATH}/:supplierCategoryId/results/:supplierSpecialty/:supplierId`,
          element: RoutesConfig.SINGLE_SUPPLIER.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.LONG_TERM_EQUIPMENT.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.LONG_TERM_EQUIPMENT.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.B2C_FIRST_LOGIN_LANDING.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.B2C_FIRST_LOGIN_LANDING.MODULE,
        },
      ],
    },
    {
      element: RoutesConfig.B2C_ERROR.MODULE,
      path: RoutesConfig.B2C_ERROR.PATH,
    },
    {
      element: RoutesConfig.PRIVATE_LAYOUT.MODULE,
      path: RoutesConfig.REIMBURSEMENTS.PATH,
      children: [
        {
          index: true,
          element: RoutesConfig.REIMBURSEMENTS.MODULE,
        },
        {
          path: RoutesConfig.CANNABIS.PATH,
          element: RoutesConfig.CANNABIS.MODULE,
        },
        {
          path: RoutesConfig.ALTERNATIVE_MEDICINE.PATH,
          element: RoutesConfig.ALTERNATIVE_MEDICINE.MODULE,
        },
      ],
    },
  ];

  const privateRoutes = useRoutes(privateRoutesConfig);

  return privateRoutes;
};
